import { gql } from '@apollo/client';

export default gql`
  mutation DeletePriority($deletePriorityId: String!) {
    deletePriority(id: $deletePriorityId) {
      count
    }
  }
`;
